// Hash-linked navigation (e.g. /services#teeth-whitening) is handled by a
// scroll effect in src/components/layout.tsx, which accounts for the sticky
// header height. Disable Gatsby's default scroll-to-top so it doesn't fight
// that effect.
exports.shouldUpdateScroll = ({ routerProps: { location } }) => {
  if (location.hash) return false
  return true
}
